import './ErrorFallback.css';

// Fallback for the root Sentry.ErrorBoundary (index.js): shown when rendering
// crashes. Deliberately dependency-free — the app tree around it may be broken.
export default function ErrorFallback() {
    return (
        <div className="app-crash-screen" role="alert">
            <div className="app-crash-card">
                <h1 className="app-crash-title">Щось пішло не так</h1>
                <p className="app-crash-text">
                    Сталася неочікувана помилка. Спробуйте перезавантажити сторінку.
                </p>
                <button
                    type="button"
                    className="app-crash-button"
                    onClick={() => window.location.reload()}
                >
                    Перезавантажити сторінку
                </button>
            </div>
        </div>
    );
}
